export const coOrderedPartsTable = [
  {
    source: 'ordered_part_id',
    sortable: true,
    title: 'Id',
    selectable: true,
  },
  {
    source: 'ordered_type',
    sortable: true,
    title: 'Ordered type',
    selectable: true,
  },
  {
    source: 'ordered_part_status',
    sortable: true,
    title: 'Part status',
    selectable: true,
  },
  {
    source: 'ordered_part_order_date',
    sortable: true,
    title: 'Order date',
    selectable: true,
  },
  {
    source: 'ordered_part_po',
    sortable: true,
    title: 'PO',
    selectable: true,
  },
  {
    source: 'ordered_part_vendor',
    sortable: true,
    title: 'Vendor',
    selectable: true,
  },
  {
    source: 'ordered_part_mpn',
    sortable: true,
    title: 'Part mpn',
    selectable: true,
  },
  {
    source: 'ordered_part_qty_delivered',
    sortable: true,
    title: 'Delivered',
    selectable: true,
  },
  {
    source: 'ordered_part_qty_in_order',
    sortable: true,
    title: 'Ordered',
    selectable: true,
  },
  {
    source: 'ordered_part_qty_return',
    sortable: true,
    title: 'Qty return',
    selectable: true,
  },
  {
    source: 'ordered_part_tracking',
    sortable: false,
    title: 'Tracking',
    selectable: true,
  },
  {
    source: 'ordered_part_note',
    sortable: false,
    title: 'Note',
    selectable: true,
  },
  {
    source: 'ordered_part_price_paid',
    sortable: true,
    title: 'Price paid',
    selectable: true,
  },
  {
    source: 'ordered_part_price_in_order',
    sortable: true,
    title: 'Item Price',
    selectable: true,
  },
  {
    source: 'ordered_part_est_delivery_date',
    sortable: true,
    title: 'Est Delivery',
    selectable: true,
  },
  {
    source: 'ordered_part_delivered_date',
    sortable: true,
    title: 'Delivered date',
    selectable: true,
  },
  {
    source: 'ordered_part_type',
    sortable: true,
    title: 'Part type',
    selectable: true,
  },
  {
    source: 'ordered_part_brand',
    sortable: true,
    title: 'Part brand',
    selectable: true,
  },
  {
    source: 'ordered_part_included',
    sortable: false,
    title: 'Include',
    selectable: true,
  },
  {
    source: 'ordered_part_agent',
    sortable: false,
    title: 'Agent',
    selectable: true,
  },
];

export default coOrderedPartsTable;
